import { useContext, React, useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import {
  AlignmentType,
  Document,
  //HeadingLevel,
  //HeadingLevel,
  BorderStyle,
  Footer,
  Packer,
  Paragraph,
  PageNumber,
  //PageBreak,
  Table,
  TableRow,
  ImageRun,
  //NumberFormat,
  //TabStopPosition,
  //TabStopType,
  //Tab,
  TableCell,
  VerticalAlign,
  WidthType,
  //TextDirection,
  TextRun,
  //Alignment,
} from "docx";
import axios from "axios";



function RaporOzet() {


  const [isLoading,setIsLoading] = useState(false);
  
  const {
    API_URL,
    user,
    userKredi,
    setUserKredi,
    davaTarihi,
    dosyaYili,
    davaci,
    davali,
    dosyaNo,
    mahkemeTuru,
    dosyaTuru,
    davaTuru,
    secilenIlce,
    secilenSehir,
    tasinmazSecilenSehir,
    tasinmazSecilenIlce,
    tasinmazSecilenKoyMahalle,
    adaNo,
    parselNo,
    metreKare,
    mevkii,
    tasinmazVasfi,
    kamulasacakMetreKare,
    //tasinmazMalikleri,
    sulamaAciklama,
    malikListesi,
    tasinmazEgimi,
    araziYapisi,
    toprakBunyesi,
    koyeUzaklik,
    ilceUzaklik,
    kesifAnlatim,
    kesifTarihi,
    kapitalizasyonFaizOrani,
    evrakList,

    //objektifUnsurlar,
    agacListesi,
    ormanAgacListesi,
    ormanAgaciVar,
    meyveVar,
    emlakBeyani,
    emlakBeyaniEvraki,
    oncekidegerlemevarmi,
    oncekidegerleme,
    gelenListe,
    davaciAvukati,
    davaliAvukati,
    masrafUcteBirMi,

    //topNetGelir,
    ortNetGelir,
    odaToplam,

    //oncekidegerlemetoplamfiyat,
    setOncekiDegerlemeToplamFiyat,

    birinciBilirkisi,

    ikinciBilirkisi,

    ucuncuBilirkisi,

    dorduncuBilirkisi,

    besinciBilirkisi,

    altinciBilirkisi,

    //RESİMLER
    konumResim,

    birinciResim,

    ikinciResim,
  } = useContext(GlobalContext);

  const aylar = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const raporTarihi = new Date();

  const oncekidegerlemet = oncekidegerlemevarmi
    ? oncekidegerleme.oncekidegerlemetarih.slice(8, 10) +
      "." +
      oncekidegerleme.oncekidegerlemetarih.slice(5, 7) +
      "." +
      oncekidegerleme.oncekidegerlemetarih.slice(0, 4)
    : ".../.../....";
  const emlakt = emlakBeyaniEvraki
    ? emlakBeyaniEvraki.emlakbeyantarih.slice(8, 10) +
      "." +
      emlakBeyaniEvraki.emlakbeyantarih.slice(5, 7) +
      "." +
      emlakBeyaniEvraki.emlakbeyantarih.slice(0, 4)
    : ".../.../....";

  const dt = davaTarihi
    ? davaTarihi.slice(8, 10) +
      "." +
      davaTarihi.slice(5, 7) +
      "." +
      davaTarihi.slice(0, 4)
    : ".../.../....";

  const kt = kesifTarihi
    ? kesifTarihi.slice(8, 10) +
      "." +
      kesifTarihi.slice(5, 7) +
      "." +
      kesifTarihi.slice(0, 4)
    : ".../.../....";

  //const navigate = useNavigate();
  const evrakTarihi =
    evrakList.length > 0
      ? evrakList[0].tarih.slice(8, 10) +
        "." +
        evrakList[0].tarih.slice(5, 7) +
        "." +
        evrakList[0].tarih.slice(0, 4)
      : ".../.../....";

  const [ciplakarazidegeri, setCiplakAraziDegeri] = useState(0);
  const [odaEklenmisAraziDegeri, setodaEklenmisAraziDegeri] = useState(0);

  useEffect(() => {
    var cad = ortNetGelir / kapitalizasyonFaizOrani;
    setCiplakAraziDegeri(cad);

    var odaad =
      ortNetGelir / kapitalizasyonFaizOrani +
      ((ortNetGelir / kapitalizasyonFaizOrani) * odaToplam) / 100;
    setodaEklenmisAraziDegeri(odaad.toFixed(2));

    var oncekidegerlemetoplamdeger = oncekidegerleme.oncekidegerlemetoplamfiyat;
    console.log("oncekidegerlenetoplamdeger :>> ", oncekidegerlemetoplamdeger);
    setOncekiDegerlemeToplamFiyat(oncekidegerlemetoplamdeger);
  }, []);

  const m2fiyati = (parseFloat(odaEklenmisAraziDegeri) / 1000).toFixed(2);
  const kamulaştırmazeminbedeli = (
    m2fiyati * parseFloat(kamulasacakMetreKare)
  ).toFixed(2);

  var meyveAgaciFiyatToplami = 0;
  meyveVar &&
    agacListesi.map(
      (agac) =>
        (meyveAgaciFiyatToplami =
          meyveAgaciFiyatToplami +
          parseFloat(agac.adetFiyati).toFixed(2) *
            parseFloat(agac.agacAdet).toFixed(2))
    );

  var ormanAgaciFiyatToplami = 0;
  ormanAgaciVar &&
    ormanAgacListesi.map((agac) =>
      (ormanAgaciFiyatToplami =
        ormanAgaciFiyatToplami +
        ((((3.14 * parseFloat(agac.cap)) / 2) * parseFloat(agac.cap)) / 2) *
          parseFloat(agac.yukseklik) *
          parseFloat(agac.ormanAgaciAdet) *
          parseFloat(agac.m3Fiyati)).toFixed(2)
    );

  const toplamAgacFiyati = (
    meyveAgaciFiyatToplami + ormanAgaciFiyatToplami
  ).toFixed(2);

  const toplamkamulastirmabedeli = (
    parseFloat(kamulaştırmazeminbedeli) + parseFloat(toplamAgacFiyati)
  ).toFixed(2);

  const meyveAgaciTablosu = () =>
    agacListesi &&
    agacListesi.map(
      (agac) =>
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(agac.agacAdi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.agacYasi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.adetFiyati)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.agacAdet)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: (
                    parseFloat(agac.adetFiyati) * parseFloat(agac.agacAdet)
                  )
                    .toFixed(2)
                    .toString(),
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        })
    );

  const ormanAgaciTablosu = () =>
    ormanAgacListesi &&
    ormanAgacListesi.map(
      (agac) =>
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(agac.ormanAgacAdi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.cap)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.yukseklik)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.ormanAgaciAdet)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.m3Fiyati)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: (
                    ((((3.14 * parseFloat(agac.cap)) / 2) *
                      parseFloat(agac.cap)) /
                      2) *
                    parseFloat(agac.yukseklik) *
                    parseFloat(agac.ormanAgaciAdet) *
                    parseFloat(agac.m3Fiyati)
                  )
                    .toFixed(2)
                    .toString(),
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        })
    );

  //MÜNAVEBE TABLOSU OLUŞTURMA
  const munabebeTablosu = () =>
    masrafUcteBirMi
      ? gelenListe &&
        gelenListe.map(
          (urun) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(urun.urunAdi)],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunVerim).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunFiyat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.yanUrunGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        (parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                          parseFloat(urun.yanUrunGelir)) /
                        3
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      text: (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir) -
                        (parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                          parseFloat(urun.yanUrunGelir)) /
                          3
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }),
                    }),
                  ],
                }),
              ],
            })
        )
      : gelenListe &&
        gelenListe.map(
          (urun) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(urun.urunAdi)],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunVerim).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunFiyat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.yanUrunGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.masraf).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      text: (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir) -
                        parseFloat(urun.masraf)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }),
                    }),
                  ],
                }),
              ],
            })
        );

  //var toplamSayfa = PageNumber.TOTAL_PAGES;

  // const reduceCredit = async () => {
  //   try {
      
  //     const response = await axios.post(API_URL+"/reduce-credit", {
  //       username: user,
  //       userKredi:userKredi// Gönderilen body
  //     });
      
  //     window.alert(response.data.message); // Başarılı yanıt mesajı
  //     response.status===200&&setUserKredi(userKredi - 1);
  //   } catch (error) {
  //     if (error.response) {
  //       // Backend'den gelen hata mesajı
  //       window.alert(error.response.data.error);
  //     } else {
  //       // Diğer hatalar (örneğin, bağlantı hatası)
  //       //console.error("Hata:", error);
  //       window.alert("Bir hata oluştu.");
  //     }
  //   }
  // };

const reduceCredit = async () => {
  if (!user || !userKredi || isNaN(parseInt(userKredi, 10))) {
    window.alert("Geçerli bir kullanıcı ve kredi miktarı giriniz.");
    return;
  }

  setIsLoading(true);

  try {
    const response = await axios.post(`${API_URL}/reduce-credit`, {
      username: user,
      userKredi: parseInt(userKredi, 10),
    });

    // Backend'den güncel kredi bilgisini al
    if (response.data?.updatedKredi !== undefined) {
      setUserKredi(response.data.updatedKredi);
    }

    window.alert(response.data?.message || "İşlem başarılı.");
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      const errorMessage = data?.error || "Bilinmeyen bir hata oluştu.";

      if (status === 401) {
        window.alert("Yetkiniz yok.");
      } else if (status === 400) {
        window.alert("Geçersiz istek.");
      } else {
        window.alert(errorMessage);
      }
    } else {
      console.error("Hata:", error);
      window.alert("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  } finally {
    setIsLoading(false);
  }
};

  //RAPOR OLUŞTURMA FONKSİYONU

  const generate = () => {
    if (userKredi > 0) {
      try {
        reduceCredit();
        const doc = new Document({
          sections: [
            {
              footers: {
                default: new Footer({
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          children: ["Sayfa ", PageNumber.CURRENT],
                        }),
                        new TextRun({
                          children: [" / ", PageNumber.TOTAL_PAGES],
                        }),
                      ],
                    }),
                  ],
                }),
              },
              children: [
                //RAPOR BAŞLIĞI
                secilenIlce === "Merkez"
                  ? new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text:
                            "T.C. " + secilenSehir + " " + mahkemeTuru + "ne",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text:
                            "T.C. " + secilenIlce + " " + mahkemeTuru + "ne",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [
                    new TextRun({
                      text: "Bilirkişi Kurulu Raporudur",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //DOSYA NO
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text:
                        "Dosya No: " +
                        dosyaYili +
                        "/" +
                        dosyaNo +
                        " " +
                        dosyaTuru,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //TARAFLAR
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Davacı: " + davaci,
                      bold: true,
                      fontsize: 12,
                    }),
                    davaciAvukati
                      ? new TextRun({
                          text: " Vekili " + davaciAvukati,
                          bold: true,
                          fontsize: 12,
                        })
                      : new TextRun({
                          text: " ",
                          bold: true,
                          fontsize: 12,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Davalı: " + davali,
                      bold: true,
                      fontsize: 12,
                    }),
                    davaliAvukati
                      ? new TextRun({
                          text: " Vekili " + davaliAvukati,
                          bold: true,
                          fontsize: 12,
                        })
                      : new TextRun({
                          text: "",
                          bold: true,
                          fontsize: 12,
                        }),
                  ],
                }),
                //DAVA KONUSU
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Dava Konusu: " + davaTuru,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //DAVA TARİHİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Dava Tarihi: " + dt,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //KEŞİF TARİHİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Keşif Tarihi: " + kt,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "İnceleme Konusu: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        tasinmazSecilenSehir +
                        " İli " +
                        tasinmazSecilenIlce +
                        " İlçesi " +
                        tasinmazSecilenKoyMahalle +" "+
                        adaNo +
                        " Ada " +
                        parselNo +
                        " Parsel Numaralı " +
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " m2 Yüzölçümüne Sahip " +
                        tasinmazVasfi +
                        " Vasıflı Taşınmaz ",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Gözlenmesi Ve İncelenmesi İstenen Maddi Unsurlar: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Dava konusu taşınmazın Kamulaştırma Kanunu'nun 11. Maddesi gereğince değerinin hesaplanması istenmektedir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Yukarıda tarafları belirtilen dosyada bilirkişi seçilmemiz üzerine " +
                        kt +
                        " tarihinde Sayın Hâkim ve ilgililerin iştiraki ile dava konusu taşınmazın bulunduğu alana gidildi. Mahallinde ve tarafımıza verilen evraklar üzerinde ve kadastro bilirkişilerinin gösterdiği alanlarda yapmış olduğumuz inceleme ve bunlara ilişkin sonuçlar aşağıda rapor halinde sunulmuştur.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "1-) DAVA KONUSU VE TALEP:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Davacı vekilinin " +
                        dt +
                        " tarihli dilekçesi ile kamulaştırılacak taşınmazın bedel tespiti ile davacı idare adına tescili istenmiştir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "2-İNCELEME YÖNTEMİ VE BİLİMSEL VE TEKNİK DAYANAKLAR:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "A-2942 SAYILI KAMULAŞTIRMA KANUNUNUN 12. MADDESİNE GÖRE KISMİ KAMULAŞTIRMALARDA KAMULAŞTIRMA ALAN DIŞI KALAN KISMIN;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "a- Kamulaştırmaya dahil edilip edilmeyeceği; Taşınmazın tamamı kamulaştırılmaktadır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "b- Kamulaştırma Alanı Dışında Kalan Kısmın Değer Azalışı Oranı: Taşınmazın tamamı kamulaştırılacağından değer azalışı uygulanmayacaktır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- Kamulaştırma Alanı Dışında Kalan Kısmın Değer Artışı Oranı: Bulunmamaktadır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "3- İNCELEME VE DEĞERLEMELER:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "2942 sayılı Kamulaştırma kanunu 11. Ve 12. Maddesi gereğince ve Sermaye Piyasası Kurulu tarafından kabul edilen değerleme standartlarına ve 6754 sayılı Bilirkişilik Kanunu ve Bilirkişilik Kanunu Yönetmeliğinin m.55 f.1 hükmü uyarınca bilirkişi raporunda yer alması gereken hususlar tarafımızdan değerlendirilmesi neticesinde;",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "4- CİNS VE NEVİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Tapu Kaydına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: tasinmazVasfi ? tasinmazVasfi + "dır" : "Arazidir",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- İmar Planına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Taşınmaz İmar Planı Dışında olup vasfı Arazidir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- Belediye Emlak Beyanına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: emlakBeyani
                        ? "Dava dosyasında bulunan " +
                          tasinmazSecilenIlce +
                          " " +
                          emlakBeyaniEvraki.emlakbeyankurum +
                          "'nün " +
                          emlakt +
                          " tarih ve " +
                          emlakBeyaniEvraki.emlakbeyanevrakno +
                          " sayılı yazılarında taşınmazın vergi beyan değerinin " +
                          emlakBeyaniEvraki.emlakbeyanevrakinOzu +
                          " TL/m2 olduğu bildirilmektedir."
                        : "Dava Dosyasında Belediye Emlak Servisi kaydına rastlanmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "d- Keşif Tarihindeki Durumuna Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        "Keşif esnasında taşınmazın toprak yapısına ve sulama durumuna göre " +
                        araziYapisi +
                        " Arazi olduğu görülmüştür. " +
                        sulamaAciklama,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "e- Değerlemede Taşınmazın Cinsi: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Tarım Arazisi olarak kabul edilecektir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "f-Değerleme Yöntemi: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Değerlemede Taşınmazın m2 Birim Fiyatı Net Gelir Yöntemi ile Bulunacaktır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "5- YÜZÖLÇÜMÜ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Tapu Yüzölçümü: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) + " m2'dir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- Kamulaştırılacak Alanın Yüzölçümü: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        parseFloat(kamulasacakMetreKare).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) + " m2'dir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "c- Kamulaştırma Dışında Kalan Alanın Yüzölçümü: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        metreKare !== kamulasacakMetreKare
                          ? parseFloat(
                              metreKare - kamulasacakMetreKare
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) + " m2'dir."
                          : "Taşınmazın tamamı kamulaştırılacaktır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "6- KIYMETİNİ ETKİLEYEBİLECEK NİTELİK VE UNSURLARI ve TAŞINMAZIN ÖZELLİKLERİ;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- TAPU KAYDINA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    malikListesi[0].adi === ""
                      ? new TextRun({
                          text: "Tapu kaydına göre taşınmazın .......................... hissesi ................................ adına kayıtlıdır.",
                          fontsize: 12,
                        })
                      : new TextRun({
                          text:
                            "Tapu kaydına göre taşınmazın" +
                            malikListesi.map((malik) => {
                              return (
                                " " +
                                malik.pay +
                                "/" +
                                malik.payda +
                                " Hissesi " +
                                malik.adi
                              );
                            }) +
                            " adına kayıtlıdır.",
                          fontsize: 12,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- KADASTRAL DURUMU: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Fen Bilirkişisi raporu ayrıca sunulmuştur.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- İMAR PLANINA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        evrakList.length > 0
                          ? "Dosyada bulunan" +
                            evrakList.map((evrak) => {
                              return (
                                " " +
                                tasinmazSecilenIlce +
                                " " +
                                evrak.kurum +
                                "'nün " +
                                evrakTarihi +
                                " tarih ve " +
                                evrak.evrakno +
                                " sayılı"
                              );
                            }) +
                            " " +
                            "yazıları gereğince taşınmazın Arazi olduğu ve Değerlemede Arsa sayılabilmesi için gerekli şartları sağlamadığı anlaşılmıştır."
                          : "",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "d- KEŞİFTEKİ DURUMUNA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: kesifAnlatim
                        ? "Keşif günü taşınmazın " +
                          tasinmazVasfi +
                          " Arazi vasfında olduğu, bünye sınıfına göre toprak yapısının " +
                          toprakBunyesi +
                          " olduğu, ortalama eğimin %" +
                          tasinmazEgimi +
                          " civarında olduğu görülmüştür. " +
                          kesifAnlatim
                        : "Keşif günü taşınmazın " +
                          tasinmazVasfi +
                          " Arazi vasfında olduğu, bünye sınıfına göre toprak yapısının " +
                          toprakBunyesi +
                          " olduğu, ortalama eğimin %" +
                          tasinmazEgimi +
                          " civarında olduğu görülmüştür.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "e- TAŞINMAZ ÜZERİNDE BULUNAN YAPI, MÜTEMMİMCÜZ, MUHDESAT VE DİKİLİ UNSURLAR; ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                //MEYVE AĞAÇLARI TABLOSU
                meyveVar &&
                  new Paragraph({
                    alignment: AlignmentType.BOTH,
                    children: [
                      new TextRun({
                        text: "Taşınmaz üzerinde aşağıda tür, yaş ve fiyat değerleri belirtilen ağaçlar bulunmaktadır.",
                        bold: false,
                        fontsize: 12,
                      }),
                    ],
                  }),
                meyveVar
                  ? new Table({
                      rows: [
                        //Tablo Başlığı
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Adı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Yaşı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Fiyatı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Sayısı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        //Tablo Başlığı
                        ...meyveAgaciTablosu(),
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: meyveAgaciFiyatToplami
                                        .toFixed(2)
                                        .toString(),
                                      //text: ormanAgaciFiyatToplami.toString(),
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Taşınmaz üzerinde ekonomik değere sahip meyve ağacı bulunmamaktadır. ",
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({}),
                //ORMAN AĞAÇLARI TABLOSU
                ormanAgaciVar &&
                  new Paragraph({
                    alignment: AlignmentType.BOTH,
                    children: [
                      new TextRun({
                        text: "Taşınmaz üzerinde aşağıda tür, ebat ve fiyat değerleri belirtilen orman emvali ağaçlar bulunmaktadır.",
                        bold: false,
                        fontsize: 12,
                      }),
                    ],
                  }),
                ormanAgaciVar
                  ? new Table({
                      rows: [
                        //Tablo Başlığı
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Adı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Çapı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Yüksekliği",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Sayısı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Metreküp Fiyatı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        //Tablo Başlığı
                        ...ormanAgaciTablosu(),
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      //text: meyveAgaciFiyatToplami.toString(),
                                      text: ormanAgaciFiyatToplami
                                        .toFixed(2)
                                        .toString(),
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Taşınmaz üzerinde ekonomik değere sahip orman emvali ağaç bulunmamaktadır. ",
                          fontsize: 12,
                        }),
                      ],
                    }),
                //f- TAŞINMAZIN KONUM VE DİGER ÖZELLİKLERİ:
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "f- TAŞINMAZIN KONUM VE DİGER ÖZELLİKLERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //f- TAŞINMAZIN KONUM VE DİGER ÖZELLİKLERİ AÇIKLAMA:
                tasinmazSecilenIlce.includes("Merkez")
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Taşınmaz " + tasinmazSecilenKoyMahalle+" "+mevkii+" Mevkisinde bulunmakta olup, "+
                            tasinmazSecilenSehir +
                            " İl Merkezine " +
                            ilceUzaklik +
                            " metre, " +
                            tasinmazSecilenKoyMahalle +"ne "+
                            koyeUzaklik +
                            " metre mesafededir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Taşınmaz " +tasinmazSecilenKoyMahalle+" "+mevkii+" Mevkisinde bulunmakta olup,"+
                            " İlçe Merkezine " +
                            ilceUzaklik +
                            " metre, " +
                            tasinmazSecilenKoyMahalle +
                            "ne " +
                            koyeUzaklik +
                            " metre mesafededir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),

                new Paragraph({}),

                //TAŞINMAZ KONUMU
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "g- TAŞINMAZIN KONUMU",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new ImageRun({
                      type: "jpg" || "png",
                      data: Uint8Array.from(atob(konumResim), (c) =>
                        c.charCodeAt(0)
                      ),
                      transformation: {
                        width: 600,
                        height: 250,
                      },
                    }),
                  ],
                }),
                new Paragraph({}),

                //TAŞINMAZ RESİMLERİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "h- TAŞINMAZ RESİMLERİ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new ImageRun({
                      type: "jpg" || "png",
                      data: Uint8Array.from(atob(birinciResim), (c) =>
                        c.charCodeAt(0)
                      ),
                      transformation: {
                        width: 280,
                        height: 180,
                      },
                    }),
                    new TextRun({
                      text: "            ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new ImageRun({
                      type: "jpg" || "png",
                      data: Uint8Array.from(atob(ikinciResim), (c) =>
                        c.charCodeAt(0)
                      ),
                      transformation: {
                        width: 280,
                        height: 180,
                      },
                    }),
                  ],
                }),
                new Paragraph({}),

                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "7- VERGİ BEYANI: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //EMLAK BEYANI
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: emlakBeyani
                        ? "Dava dosyasında bulunan " +
                          tasinmazSecilenSehir+"/"+tasinmazSecilenIlce +
                          " " +
                          emlakBeyaniEvraki.emlakbeyankurum +
                          "'nün " +
                          emlakt +
                          " tarih ve " +
                          emlakBeyaniEvraki.emlakbeyanevrakno +
                          " sayılı yazılarında taşınmazın vergi beyan değerinin " +
                          emlakBeyaniEvraki.emlakbeyanevrakinOzu +
                          " TL/m2 olduğu bildirilmektedir."
                        : "Dava Dosyasında Belediye Emlak Servisi kaydına rastlanmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //ÖNCEKİ KIYMET TAKDİRLERİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "8-KAMULAŞTIRMA TARİHİNDEKİ RESMİ MAKAMLARCA YAPILMIŞ KIYMET TAKDİRLERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: oncekidegerlemevarmi
                        ? "Dava dosyasında bulunan ve " +
                          oncekidegerleme.degerlemeyapankurum +
                          "'nce yapılan " +
                          oncekidegerlemet +
                          " tarihli Kıymet Takdir Raporunda taşınmaza " +
                          oncekidegerleme.oncekidegerlememetrekarefiyati +
                          " TL/m2 değer biçilmiş olup kamulaştırılacak taşınmazın değeri " +
                          parseFloat(
                            oncekidegerleme.oncekidegerlemetoplamfiyat
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          " TL olarak takdir edilmiştir."
                        : "Dava Dosyasında önceki değerleme evrakına rastlanmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //KFO
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "9- ARAZİLERDE TAŞINMAZ MAL VE KAYNAĞIN MEVKİİ ŞARTLARINA GÖRE VE OLDUĞU GİBİ KULLANILMASI HALİNDE GETİRECEĞİ NET GELİR;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Kapitalizasyon Faiz Oranı;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Kapitalizasyon Faiz Oranına yönelik hesaplamalarda yörede mevcut satışı yapılan alanlardaki değerlendirmeler, taşınmazın " +
                        araziYapisi +
                        " arazi olması ve " +
                        dosyaYili +
                        " yılı net gelir hesaplamaları da değerlendirilerek elde edilen kapitalizasyon faiz oranı %" +
                        (kapitalizasyonFaizOrani * 100).toString() +
                        " olarak kabul görmüştür.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //ODA
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- Objektif Değer Artış Oranı;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),

                //ODA GEREKÇELERİ: SATIR İÇİ MAP ÖRNEĞİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    // new TextRun({
                    //   text:
                    //     odaToplam > 0
                    //       ? "Bilirkişi Kurulumuzca yapılan değerlendirmede " +
                    //         objektifUnsurlar.map((objektifunsur) => {
                    //           return (
                    //             " " +
                    //             objektifunsur.odaNedeni +
                    //             " nedeniyle " +
                    //             "%" +
                    //             objektifunsur.etkiOrani +
                    //             " "
                    //           );
                    //         }) +
                    //         " olmak üzere Toplam %" +
                    //         odaToplam.toString() +
                    //         " oranında objektif değer artış eklenmesi kanaati oluşmuştur."
                    //       : "Taşınmaz için yapılan net gelir hesapları ve taşınmaz ile ilgili yapılan değerlendirmeler sonucunda Bilirkişi Kurulumuzca taşınmazın değerine etki edecek objektif unsur bulunmadığı kararlaştırılmıştır.",
                    //   fontsize: 12,
                    // }),
                    new TextRun({
                      text:
                        odaToplam > 0
                          ? "Raporumuzun 6. maddesindeki taşınmazın konum ve diğer özelliklerinde belirtilen sebepler ile taşınmazın etrafında bulunan köylerin nüfus yoğunluğu ile tarıma olan ilginin fazla olması gibi sebeplerden dolayı bilirkişi kurulumuzca taşınmazın değerine %" +
                            odaToplam.toString() +
                            " oranında objektif değer artışı eklenmesi kanaati oluşmuştur."
                          : "Taşınmaz için yapılan net gelir hesapları ve taşınmaz ile ilgili yapılan değerlendirmeler sonucunda Bilirkişi Kurulumuzca taşınmazın değerine etki edecek objektif unsur bulunmadığı kararlaştırılmıştır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                //NET GELİR
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- TAŞINMAZIN NET GELİR VE METREKARE DEĞERİNİN HESAPLANMASI:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Taşınmazın Çıplak değeri (TÇD) (TL/da) = Net Gelir R (TL)/Kapitalizasyon Faiz Oranı (%) formülü ile hesap edilecektir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c-1- NET GELİRİN HESAPLANMASI TAŞINMAZIN ÇIPLAK ARAZİ DEĞERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),

                tasinmazSecilenIlce === "Merkez"
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Raporda kaynak olarak " +
                            tasinmazSecilenSehir +
                            " İl Tarım ve Orman Müdürlüğünün " +
                            dosyaYili +
                            " yılında geçerli " +
                            tasinmazSecilenSehir +
                            "/" +
                            tasinmazSecilenIlce +
                            " bölgesinde ağırlıklı olarak yetiştirilen bitkisel ürünlerin dekara verimi, tarladan toptan satış fiyatı cetvellerindeki gelir değerleri kullanılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Raporda kaynak olarak " +
                            tasinmazSecilenSehir +
                            " " +
                            tasinmazSecilenIlce +
                            " Tarım ve Orman Müdürlüğünün " +
                            dosyaYili +
                            " yılında geçerli " +
                            tasinmazSecilenSehir +
                            "/" +
                            tasinmazSecilenIlce +
                            " bölgesinde ağırlıklı olarak yetiştirilen bitkisel ürünlerin dekara verimi, tarladan toptan satış fiyatı cetvellerindeki gelir değerleri kullanılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                //Masrafın 3tebir alınıp alınmaması
                masrafUcteBirMi
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Masraf Değerleri için Brüt Gelirin 1/3'ü alınarak hesaplama yapılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Masraf Değerleri için Tarım Müdürlüğü verilerinde bulunan masraf değerleri ile hesaplama yapılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Bilirkişi Kurulumuzca kıymet takdirinin " +
                        dosyaYili +
                        " yılı",
                      bold: false,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        gelenListe &&
                        gelenListe.map((urun) => {
                          return " " + urun.urunAdi;
                        }) +
                          " " +
                          "bitkilerinin münavebesi ile oluşacak ortalama net gelire göre değerlendirilmesi kararlaştırılmıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: dosyaYili + " Yılı",
                      bold: false,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        gelenListe &&
                        gelenListe.map((urun) => {
                          return " " + urun.urunAdi;
                        }) +
                          " " +
                          araziYapisi +
                          " Arazi",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //MÜNAVEBE TABLOSU
                new Table({
                  rows: [
                    //Tablo Başlığı
                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ürün Adı",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ana Ürün Verim",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ana Ürün Fiyat",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Yan Ürün Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Toplam Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Masraf",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Net Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    //Tablo Başlığı
                    //tablo satırları
                    ...munabebeTablosu(),
                  ],
                }),
                new Paragraph({}),
                //TABLO ALTI VERİLER
                masrafUcteBirMi
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Ortalama Net Gelir = ",
                          bold: false,
                          fontsize: 12,
                        }),
                        new TextRun({
                          text:
                            "(" +
                            gelenListe
                              .map((urun) =>
                                (
                                  parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                  parseFloat(urun.yanUrunGelir) -
                                  (parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                    parseFloat(urun.yanUrunGelir)) /
                                    3
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              )
                              .join("+") +
                            ") /" +
                            gelenListe.length.toString() +
                            "= " +
                            parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Ortalama Net Gelir = ",
                          bold: false,
                          fontsize: 12,
                        }),
                        new TextRun({
                          text:
                            "(" +
                            gelenListe
                              .map((urun) =>
                                (
                                  parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                  parseFloat(urun.yanUrunGelir) -
                                  parseFloat(urun.masraf)
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              )
                              .join("+") +
                            ") /" +
                            gelenListe.length.toString() +
                            "= " +
                            parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    odaToplam > 0
                      ? new TextRun({
                          text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı) + (Objektif Değer Artışı)",
                          bold: false,
                          fontsize: 11,
                        })
                      : new TextRun({
                          text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı) ",
                          bold: false,
                          fontsize: 11,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Bir Dekar Arazi Değeri =",
                      bold: false,
                      fontsize: 11,
                    }),
                    new TextRun({
                      text:
                        odaToplam > 0
                          ? parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL/Da" +
                            " / " +
                            kapitalizasyonFaizOrani.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " + " +
                            ciplakarazidegeri.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " x " +
                            (odaToplam / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " = " +
                            parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL/Da'dır."
                          : parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " " +
                            "TL/Da" +
                            " / " +
                            kapitalizasyonFaizOrani.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " = " +
                            parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL/Da'dır.",
                      bold: false,
                      fontsize: 11,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Bir m2 Arazi Değeri = " +
                        parseFloat(m2fiyati).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " TL/m2'dir.",
                      bold: true,
                      fontsize: 11,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Kamulaştırılacak Alanın Değeri= " +
                        parseFloat(m2fiyati).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " TL/m2 x " +
                        parseFloat(kamulasacakMetreKare).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " m2",
                      bold: true,
                      fontsize: 11,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Kamulaştırılacak Alanın Değeri= " +
                        parseFloat(kamulaştırmazeminbedeli).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " TL'dir.",
                      bold: true,
                      fontsize: 11,
                    }),
                  ],
                }),
                //BURASI DEĞER AZALIŞI OLURSA YENİDEN DİZAYN EDİLECEK
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c-2- KAMULAŞTIRMA HARİCİ KALAN KISMIN DEĞER DÜŞÜKLÜĞÜNÜN HESAPLANMASI: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Kamulaştırma alanı dışında kalan kısım bulunmamaktadır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "10- ARSALARDA KAMULAŞTIRMA ÖNCESİ ÖZEL AMACI OLMAYAN EMSAL SATIŞLARA GÖRE SATIŞ DEĞERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Taşınmazın vasfı Arazi olduğundan arsa ile ilgili hesaplama yapılmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //BURASI TAŞINMAZ ÜZERİNDE YAPI DURUMUNA GÖRE TEKRAR DİZAYN EDİLECEK
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "11- YAPILARDA RESMİ BİRİM FİYATLARI VE YAPI MALİYET HESAPLARINI VE YIPRANMA PAYINI: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Taşımaz üzerinde yapı bulunmamaktadır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //SONUÇ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "12-SONUÇ OLARAK: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Dava tarihi olan " +
                        dt +
                        " itibari ile yukarıda yapılan hesaplamalar neticesinde:",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //KAMULAŞTIRMA ZEMİN DEĞERİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "a-	Kamulaştırılacak Alanının Değeri: " +
                        parseFloat(kamulasacakMetreKare).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " m2: " +
                        parseFloat(kamulaştırmazeminbedeli).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " TL'dir. ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //KAMULAŞTIRMA AĞAÇ BEDELİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        toplamAgacFiyati > 0
                          ? "b-	Kamulaştırma Alanında Bulunan Ağaçların Değeri: " +
                            parseFloat(toplamAgacFiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir."
                          : "",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Bilirkişi Kurulumuzca Takdir Edilen Toplam Kamulaştırma Bedeli: " +
                        parseFloat(toplamkamulastirmabedeli).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " TL'dir.",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: oncekidegerlemevarmi
                        ? "Kurum Tarafından Takdir Edilen Toplam Kamulaştırma Bedeli: " +
                          parseFloat(
                            oncekidegerleme.oncekidegerlemetoplamfiyat
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          " TL'dir."
                        : " Dava Dosyasında önceden yapılmış değerleme verisine rastlanmamıştır.",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: oncekidegerlemevarmi
                        ? "Değerlemeler Arasındaki Fark: " +
                          (
                            parseFloat(toplamkamulastirmabedeli) -
                            parseFloat(
                              oncekidegerleme.oncekidegerlemetoplamfiyat
                            )
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          " TL'dir."
                        : "",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),

                toplamkamulastirmabedeli > 0 &&
                  new Paragraph({
                    alignment: AlignmentType.BOTH,
                    children: [
                      new TextRun({
                        text: "Taşınmazın",
                        bold: false,
                        fontsize: 12,
                      }),
                      new TextRun({
                        text:
                          "" +
                          malikListesi.map((malik) => {
                            return (
                              " " +
                              malik.pay +
                              "/" +
                              malik.payda +
                              " Hissesi " +
                              malik.adi +
                              " adına kayıtlı olduğundan hissesine: " +
                              (
                                (parseFloat(toplamkamulastirmabedeli) /
                                  parseFloat(malik.payda)) *
                                parseFloat(malik.pay)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) +
                              " TL"
                            );
                          }) +
                          " kamulaştırma bedeli isabet etmektedir.",
                        bold: false,
                        fontsize: 12,
                      }),
                    ],
                  }),
                new Paragraph({}),
                new Paragraph({}),

                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Görüş ve kanaatimizi içeren iş bu bilirkişi raporunda 6754 sayılı Bilirkişilik Kanunu ve Bilirkişilik Kanunu Yönetmeliğinin m.55 f.1 hükmü uyarınca bilirkişi raporunda yer alması gereken hususlar tarafımızca değerlendirilmiş olup, Nihai Takdir Mahkemenize ait olmak üzere saygılarımızla arz ederiz. " +
                        raporTarihi.getDate() +
                        "." +
                        aylar[raporTarihi.getMonth()] +
                        "." +
                        raporTarihi.getFullYear(),
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? ikinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? ikinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? "Sicil No: " +
                                      ikinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? ucuncuBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? ucuncuBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? "Sicil No: " +
                                      ucuncuBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? birinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? birinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? "Sicil No: " +
                                      birinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),

                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? besinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? besinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? "Sicil No: " +
                                      besinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? dorduncuBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? dorduncuBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? "Sicil No: " +
                                      dorduncuBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? altinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? altinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? "Sicil No: " +
                                      altinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            },
          ],
        });

        Packer.toBlob(doc).then((blob) => {
          console.log(blob);
          saveAs(blob, "example.docx");
          console.log("Document created successfully");
        });

        
      } catch (error) {
        window.alert("Münavebe Tablosunu Kontrol Ediniz");
      }
    } else {
      window.alert("Krediniz Kalmadı. Lüften Bağış Yapınız :(");
    }
  };

  return (
    <GlobalProvider>
      <div className="container my-5">
        <h1 className="text-center text-primary mb-5">RAPOR ÖZETİ</h1>

        {/* Tek Tablo */}
        <table className="table table-bordered table-striped text-center">
          <thead className="bg-primary text-white">
            <tr>
              <th colSpan="6" className="h4">
                Rapor Detayları
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Dosya Bilgileri */}
            <tr className="bg-secondary text-white">
              <th colSpan="6">Dosya Bilgileri</th>
            </tr>
            <tr>
              <th>Adliye</th>
              <td>
                {secilenSehir}/{secilenIlce}
              </td>
              <th>Mahkeme</th>
              <td>{mahkemeTuru}</td>
              <th>Dosya Yılı/No</th>
              <td>
                {dosyaYili}/{dosyaNo} {dosyaTuru}
              </td>
            </tr>
            <tr>
              <th>Dava Konusu</th>
              <td>{davaTuru}</td>
              <th>Davacı</th>
              <td>{davaci}</td>
              <th>Davalı</th>
              <td>{davali}</td>
            </tr>
            <tr>
              <th>Dava Tarihi</th>
              <td>{dt}</td>
              <th>Keşif Tarihi</th>
              <td>{kt}</td>
              <td colSpan="2"></td>
            </tr>

            {/* Taşınmaz Bilgileri */}
            <tr className="bg-success text-white">
              <th colSpan="6">Taşınmaz Bilgileri</th>
            </tr>
            <tr>
              <th>İl/İlçe</th>
              <td>
                {tasinmazSecilenSehir}/{tasinmazSecilenIlce}
              </td>
              <th>Köy/Mahalle</th>
              <td>{tasinmazSecilenKoyMahalle}</td>
              <th>Ada</th>
              <td>{adaNo}</td>
            </tr>
            <tr>
              <th>Parsel</th>
              <td>{parselNo}</td>
              <th>Alan</th>
              <td>{metreKare} m²</td>
              <th>Mevkii</th>
              <td>{mevkii}</td>
            </tr>
            <tr>
              <th>Vasfı</th>
              <td>{tasinmazVasfi}</td>
              <th>K. Alanı</th>
              <td>{kamulasacakMetreKare}</td>
              <th>Malikler</th>
              <td>
                {malikListesi
                  .map(
                    (malik) =>
                      `${malik.pay}/${malik.payda} Hissesi ${malik.adi}`
                  )
                  .join(", ")}
              </td>
            </tr>

            {/* Değerleme Verileri */}
            <tr className="bg-warning text-dark">
              <th colSpan="6">Değerleme Verileri</th>
            </tr>
            <tr>
              <th>Ortalama Gelir</th>
              <td>{ortNetGelir.toFixed(2)} TL</td>
              <th>KFO</th>
              <td>{kapitalizasyonFaizOrani}</td>
              <th>Arazi Değeri</th>
              <td>{ciplakarazidegeri.toFixed(2)} TL/DA</td>
            </tr>
            <tr>
              <th>ODA</th>
              <td>%{odaToplam}</td>
              <th>ODA + Arazi</th>
              <td>{odaEklenmisAraziDegeri} TL/DA</td>
              <th>Meyve Ağaçları</th>
              <td>
                {agacListesi.length > 0
                  ? agacListesi
                      .map((agac) => agac.agacAdi.toUpperCase())
                      .join(", ")
                  : "Yok"}
              </td>
            </tr>
            <tr>
              <th>Orman Ağaçları</th>
              <td>
                {ormanAgacListesi.length > 0
                  ? ormanAgacListesi
                      .map((agac) => agac.ormanAgacAdi.toUpperCase())
                      .join(", ")
                  : "Yok"}
              </td>
              <td colSpan="4"></td>
            </tr>
          </tbody>
        </table>

        {/* Düğmeler */}
        <div className="row mt-4">
          <div className="col-6 text-start">
            <Link to="/resimekle">
              <button className="btn btn-success btn-lg">
                <i className="bi bi-arrow-left-circle me-2"></i>Resim Ekleme
              </button>
            </Link>
          </div>
          <div className="col-6 text-end">
            <button onClick={generate} className="btn btn-primary btn-lg">
              Rapor Yaz <i className="bi bi-arrow-right-circle ms-2"></i>
            </button>
          </div>
        </div>
      </div>

      <div></div>
    </GlobalProvider>
  );
}

export default RaporOzet;
